import React from 'react';

const SpinnerComponent = () => {
    return (
        <div className="spinner-container">
            <svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle className="spinner_b2T7" cx="4" cy="12" r="3" />
                <circle className="spinner_b2T7 spinner_YRVV" cx="12" cy="12" r="3" />
                <circle className="spinner_b2T7 spinner_c9oY" cx="20" cy="12" r="3" />
            </svg>
        </div>
    );
};

export default SpinnerComponent;
